import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class PropostaStateService {
    constructor() {
        this.propostaBase = { plataformaInclusao: 'WEB', transients: {}, carencia: 0 };
        this.proposta = new BehaviorSubject(this.propostaBase);
        this.proposta$ = this.proposta.asObservable();
    }
    getLast() {
        const entity = this.proposta.getValue();
        return Object.assign({}, entity, { transients: Object.assign({}, entity.transients), valorEntrada: 0 });
    }
    getState() {
        return this.proposta$;
    }
    setState(proposta) {
        this.proposta.next(proposta);
    }
    clear() {
        console.log('Limpando estado da proposta');
        this.setState(this.propostaBase);
    }
}
PropostaStateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PropostaStateService_Factory() { return new PropostaStateService(); }, token: PropostaStateService, providedIn: "root" });
